export const saveScrollPosition = (page, tab, position) => ({
    type: 'SAVE_SCROLL_POSITION',
    payload: {
        page,
        tab,
        position
    }
});

export const setCurrentPage = (page) => ({
    type: 'SET_CURRENT_PAGE',
    payload: page
});

export const setCurrentTab = (tab) => ({
    type: 'SET_CURRENT_TAB',
    payload: tab
});

export const restoreScrollPosition = (page, tab) => ({
    type: 'RESTORE_SCROLL_POSITION',
    payload: {
        page,
        tab
    }
});

export const stopScrolling = (value) => ({
    type: 'STOP_SCROLLING',
    payload: value
});

export const setHideBottomNav = (value) => ({
    type: 'SET_HIDE_BOTTOM_NAV',
    payload: value
});

// Helper function to get current scroll position
export const getCurrentScrollPosition = () => {
    return window.pageYOffset || document.documentElement.scrollTop;
};

// Helper function to restore scroll position
export const scrollToPosition = (position) => {
    if (position > 0) {
        requestAnimationFrame(() => {
            window.scrollTo(0, position);
        });
    }
}; 